import { render, staticRenderFns } from "./ListItemOptionInstitution.vue?vue&type=template&id=6c74e740&scoped=true&"
import script from "./ListItemOptionInstitution.vue?vue&type=script&lang=js&"
export * from "./ListItemOptionInstitution.vue?vue&type=script&lang=js&"
import style0 from "./ListItemOptionInstitution.vue?vue&type=style&index=0&id=6c74e740&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74e740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c74e740')) {
      api.createRecord('6c74e740', component.options)
    } else {
      api.reload('6c74e740', component.options)
    }
    module.hot.accept("./ListItemOptionInstitution.vue?vue&type=template&id=6c74e740&scoped=true&", function () {
      api.rerender('6c74e740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/components/ListItemOptionInstitution.vue"
export default component.exports